import React from 'react';

import { Hero } from './parts/Hero';
import About from './parts/About';
import Offer from './parts/Offer';
import { CTA } from './parts/CTA';
import SEOHead from '../components/SEOHead';

const Home = () => {
  return (
    <>
      <SEOHead page="home" />
      <Hero />
      <About />
      <Offer />
      <CTA />
    </>
  );
};

export { Home };
